import { render, staticRenderFns } from "./KeywordRecommendSchemes.vue?vue&type=template&id=cd732a6e"
import script from "./KeywordRecommendSchemes.vue?vue&type=script&lang=js"
export * from "./KeywordRecommendSchemes.vue?vue&type=script&lang=js"
import style0 from "./KeywordRecommendSchemes.vue?vue&type=style&index=0&id=cd732a6e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports